import {
    Grid,
    TextField,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@material-ui/core';
import {P, PBold, PSingleLine} from 'components/TypographyShortcuts';
import {LoadingPage} from 'components';
import {ErrorPage} from 'components/LoadingPage';
import {ExpandMore} from '@material-ui/icons';
import VesselCard from './VesselCard';
import {useCallback, useRef} from 'react';

const VesselSearch = ({
    hasRecommended,
    query,
    handleQueryChange,
    searchResults,
    selectedId,
    handleDetailVesselUpdate,
    setPageNumber,
    hasMore,
}) => {
    const observer = useRef();
    const vessels = searchResults?.vessels;

    const lastElementRef = useCallback(
        node => {
            if (searchResults?.isLoading) return;
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting && hasMore) {
                    setPageNumber(prevPage => prevPage + 1);
                }
            });
            if (node) observer.current.observe(node);
        },
        //eslint-disable-next-line
        [searchResults?.isLoading, hasMore]
    );

    return (
        <Accordion defaultExpanded={!hasRecommended && !selectedId}>
            <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls='search-vessels-content'
                id='search-vessels-header'
            >
                <PBold align='center'>Vessel Search</PBold>
            </AccordionSummary>
            <AccordionDetails style={{padding: '8px'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <P>
                            Start typing Vessel Name, Registration Number, or
                            Operating Company to see if it's already in our
                            Vessel Database. Please enter at least 3 characters
                            to activate the search.
                        </P>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label='Look for your vessel here'
                            variant='outlined'
                            value={query}
                            onChange={handleQueryChange}
                            fullWidth
                            onKeyPress={e => {
                                if (e.key === 'Enter') e.preventDefault();
                            }}
                            inputProps={{
                                'data-cy': 'form-field-vessel_search',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {searchResults?.error ? (
                            <ErrorPage />
                        ) : searchResults?.nResults === 0 ? (
                            <PSingleLine align='center'>
                                No results found matching your search.
                            </PSingleLine>
                        ) : searchResults?.vessels?.length ? (
                            <PSingleLine align='center'>
                                {searchResults?.nResults} vessels found.
                            </PSingleLine>
                        ) : null}
                    </Grid>
                    <Grid
                        item
                        container
                        spacing={1}
                        xs={12}
                        style={{
                            maxHeight: '400px',
                            minHeight: '200px',
                            overflowY: 'scroll',
                        }}
                    >
                        {vessels?.map((vessel, index) => (
                            <Grid item xs={12} key={vessel?.mmseas_uuid}>
                                <VesselCard
                                    vessel={vessel}
                                    selectedId={selectedId}
                                    handleDetailVesselUpdate={
                                        handleDetailVesselUpdate
                                    }
                                    innerRef={
                                        index + 1 ===
                                        searchResults?.vessels?.length
                                            ? lastElementRef
                                            : null
                                    }
                                />
                            </Grid>
                        ))}
                        {searchResults?.isLoading ? (
                            [
                                <Grid item key='spacing' />,
                                <Grid item xs={12} key='loading'>
                                    <LoadingPage>
                                        Loading more vessels...
                                    </LoadingPage>
                                </Grid>,
                            ]
                        ) : !hasMore &&
                          query.length &&
                          searchResults?.nResults !== 0 ? (
                            <Grid item xs={12}>
                                <P align='center'>End of search results</P>
                            </Grid>
                        ) : null}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default VesselSearch;
